/**
 * Claves de la caché de consultas. Están aquí, y no en cada funcionalidad, porque una acción sobre un
 * usuario cambia varias vistas a la vez (la lista, su ficha, su historial y la auditoría del día).
 */
export const claves = {
  usuarios: ["usuarios"] as const,
  ficha: (usuarioId: string) => ["ficha", usuarioId] as const,
  historial: (usuarioId: string) => ["historial", usuarioId] as const,
  instituciones: ["instituciones"] as const,
  auditoria: ["auditoria"] as const,
  auditoriaDelDia: (dia: string) => ["auditoria", dia] as const,
};

/** Lo que cambia cuando BVL actúa sobre un usuario. */
export function trasCambiarUsuario(usuarioId: string): readonly (readonly string[])[] {
  return [claves.usuarios, claves.ficha(usuarioId), claves.historial(usuarioId), claves.auditoria];
}
